var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatsIcon = function SvgChatsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 2.25H3.75C2.50725 2.25 1.5 3.25725 1.5 4.5V14.25V14.871C1.5 16.1805 2.9805 16.9425 4.04625 16.1813L6.16275 14.6693C6.5445 14.3962 7.002 14.25 7.47075 14.25H14.25C15.4927 14.25 16.5 13.2428 16.5 12V4.5C16.5 3.25725 15.4927 2.25 14.25 2.25Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.25 7.5H6.75C6.33525 7.5 6 7.164 6 6.75C6 6.336 6.33525 6 6.75 6H11.25C11.6647 6 12 6.336 12 6.75C12 7.164 11.6647 7.5 11.25 7.5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.75 10.5H6.75C6.33525 10.5 6 10.164 6 9.75C6 9.336 6.33525 9 6.75 9H9.75C10.1648 9 10.5 9.336 10.5 9.75C10.5 10.164 10.1648 10.5 9.75 10.5Z",
    fill: "#E0E0E0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chats-icon.4aa75f70e0e115e515112e3d3aa50be2.svg";